import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { loginRequest, loginSuccess, loginFailure } from '../reducers/login';
import { xapiRequest } from '../reducers/xapi';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/login`;

function getUserTimeZone() {
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return userTimeZone;
}

// Usage example
const userTimeZone = getUserTimeZone();


function* loginFunctionAxios() {
  const state = yield select(fullState => fullState);
  const { Email: email, Password: password } = state.form.login.values;
  const response = yield call(() =>
    axios({
      method: 'post',
      url: API,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      data: {
        email,
        password,
        type: 'client',
        userTimeZone:userTimeZone
      },
    }),
  );

  return response;
}

function* workerLoginSaga() {
  
  try {
  
    const response = yield call(loginFunctionAxios);

    const responseFromLogin = response.data;
   
    if (response.status === 200) {
      
      yield put(loginSuccess(responseFromLogin));
    }

    if (response.status === 205) {
      yield put(loginFailure('Email does not exist'));
    }

    if (response.status === 206) {
      yield put(loginFailure(responseFromLogin));
    }

    if (response.status === 500) {
      yield put(loginFailure('internal server error'));
    }
  } catch (error) {
    yield put(loginFailure(error));
  }
}

export function* watcherLoginSaga() {
  yield takeLatest(loginRequest().type, workerLoginSaga);
}
